import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["typeSelect"]
    static values = {
        fieldsByType: Array,
        index: String,
        type: String,
        operator: String,
        selectedOperator: String,
        group: String,
        selected: String
    }

    connect() {
        this.updateHubspotFields();
    }

    updateHubspotFields() {
        let index = this.indexValue;
        let type = this.typeValue;
        let operator = this.operatorValue;
        let selectedOperator = this.selectedOperatorValue;
        let groupIndex = this.groupValue;

        const textTypes = ['text', 'textarea', 'string', 'phonenumber']
        const numeric_types = ['number']
        const selectTypes = ['select']
        const booleanTypes = ['booleancheckbox']
        const numeric = ["GREATER", 'GREATER_OR_EQUALS', 'LESS', 'LESS_OR_EQUALS', 'IN_RANGE', 'EQUALS']
        const text = ['EQUALS', 'CONTAINS']
        const boolean = ['EQUALS']


        const selectedType = this.typeSelectTarget.value || undefined
        let field = this.fieldsByTypeValue.find((obj) => obj.name == selectedType)

        if (textTypes.includes(field.type)) {
            this.addOperator(text, index, type, operator, selectedOperator, groupIndex);
            this.replaceSelectField(index, type, groupIndex);
        } else if (numeric_types.includes(field.type)) {
            this.addOperator(numeric, index, type, operator, selectedOperator, groupIndex);
            this.replaceSelectField(index, type, groupIndex);
        } else if (booleanTypes.includes(field.type)) {
            this.addOperator(boolean, index, type, operator, selectedOperator, groupIndex, null, 'boolean');
            this.replaceUserInputField(index, type, groupIndex)
        } else if (selectTypes.includes(field.type)) {
            this.addOperator(boolean, index, type, operator, selectedOperator, groupIndex)
            this.replaceUserInputField(index, type, groupIndex, field.values, 'select')
        }
    }

    addOperator(fields, index, type, operator, selectedOperator, groupIndex) {
        const contactFieldsDiv = document.querySelector(
            `.group_${groupIndex}_operator_field_${type}_${index}`,
        );
        const existingSelect = contactFieldsDiv.querySelector("select");

        const selectElement = document.createElement("select");
        selectElement.classList.add("bc-select");
        selectElement.name = `user_integration[${type}_conditions][OR][${groupIndex}][][operator]`;

        const defaultOption = document.createElement("option");
        defaultOption.disabled = true;
        defaultOption.textContent = "Choose an operator";
        selectElement.appendChild(defaultOption);

        const options = fields.map((field) => ({ value: field, label: field }));

        options.forEach((option) => {
            const opt = document.createElement("option");
            opt.value = option.value;
            opt.textContent = option.label;

            if (opt.value == selectedOperator) {
                opt.selected = true;
            }
            selectElement.appendChild(opt);
        });

        if (existingSelect) {
            existingSelect.replaceWith(selectElement);
        } else {
            contactFieldsDiv.appendChild(selectElement);
        }
    }

    replaceSelectField(index, type, groupIndex) {
        const divElement = document.querySelector(`.group_${groupIndex}_input_${type}_${index}`)
        const existingSelect = divElement.querySelector("select")

        if (existingSelect != undefined) {
            const newInput = document.createElement('input')
            newInput.classList.add('bc-input')
            newInput.name = `user_integration[${type}_conditions][OR][${groupIndex}][][value]`;
            existingSelect.replaceWith(newInput);
        }
    }

    replaceUserInputField(index, type, groupIndex, values, fieldType) {
        const divElement = document.querySelector(`.group_${groupIndex}_input_${type}_${index}`)
        let inputField = divElement.querySelector("input")
        const newSelect = document.createElement("select")
        newSelect.classList.add('bc-select')
        newSelect.name = `user_integration[${type}_conditions][OR][${groupIndex}][][value]`;

        if (fieldType == 'boolean') {
            const trueOption = document.createElement('option')
            trueOption.textContent = 'Checked'
            trueOption.value = 'true'
            newSelect.appendChild(trueOption)

            const falseOption = document.createElement('option')
            falseOption.textContent = 'Unchecked'
            falseOption.value = 'false'
            newSelect.appendChild(falseOption)
        } else if (fieldType === 'select' && values !== null) {
            values.forEach((option) => {
                const opt = document.createElement("option");
                const value = option && typeof option === 'object' ? option.value : option;
                const label = option && typeof option === 'object'
                    ? (option.label || option.value)
                    : option;

                if (String(value) === String(this.selectedValue)) {
                    opt.selected = true;
                }

                opt.value = value;
                opt.textContent = label;
                newSelect.appendChild(opt);
            })
        }

        inputField.replaceWith(newSelect);
    }
}
